import React from "react";
import { ThemeProvider, Theme, StyledEngineProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { useReadingLayoutStyle } from "./ReadingLayout.style";
import { verbalTheme } from "../../themes/verbal.theme";
import { ReadingHeader } from "../../../../core/components/ReadingHeader";

declare module "@mui/styles/defaultTheme" {
    // eslint-disable-next-line @typescript-eslint/no-empty-interface
    interface DefaultTheme extends Theme {}
}

export const ReadingLayout: React.FC<{ children?: React.ReactNode }> = ({ children }): React.ReactElement => {
    const classes = useReadingLayoutStyle();
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={verbalTheme}>
                <CssBaseline />
                <ReadingHeader />
                <div className={classes.root}>
                    <main className={classes.main}>{children}</main>
                </div>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};
